(function () {
  // GA4 list attribution for collection grids: view_item_list when a grid is
  // meaningfully visible, select_item on product click. Recommendation surfaces
  // are excluded — they already report through recommendation_* events.
  if (typeof window.psGtag !== 'function') return;

  const reported = new WeakSet();
  const observed = new WeakSet();

  function listMeta(grid) {
    const anchor = grid.closest('[id]');
    const listId = anchor && anchor.id ? anchor.id : 'collection-grid';
    return {
      item_list_id: `${window.location.pathname}#${listId}`,
      item_list_name: listId
    };
  }

  function gridItems(grid) {
    // Дедуп: одна картка присутня в DOM двічі (desktop+mobile копії).
    const ids = [...new Set(
      [...grid.querySelectorAll('.svc-card[data-product-id]')]
        .map((card) => String(card.dataset.productId))
    )];
    return ids.slice(0, 10).map((id, index) => ({ item_id: id, index: index + 1 }));
  }

  function emitViewItemList(grid) {
    const items = gridItems(grid);
    if (!items.length) return;
    const meta = listMeta(grid);
    window.psGtag('event', 'view_item_list', {
      item_list_id: meta.item_list_id,
      item_list_name: meta.item_list_name,
      items: items
    });
  }

  function eligibleGrids() {
    return [...document.querySelectorAll('.tag-products-grid')]
      .filter((grid) => !grid.closest('[data-recommendation-block]'));
  }

  // Критерій видимості: ≥200px гріда у в'юпорті або ≥25% його висоти — що менше.
  // Гріди можуть бути і нижчі, і значно вищі за viewport; чистий ratio-поріг
  // для високих грідів недосяжний.
  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const grid = entry.target;
        if (!entry.isIntersecting || reported.has(grid)) return;
        const visiblePx = entry.intersectionRect.height;
        const need = Math.min(200, entry.boundingClientRect.height * 0.25);
        if (visiblePx < need) return;
        reported.add(grid);
        emitViewItemList(grid);
        observer.unobserve(grid);
      });
    }, { threshold: [0, 0.05, 0.1, 0.25, 0.5] })
    : null;

  document.addEventListener('click', (event) => {
    const card = event.target.closest('.svc-card[data-product-id]');
    const grid = card && card.closest('.tag-products-grid');
    if (!card || !grid || grid.closest('[data-recommendation-block]')) return;

    const meta = listMeta(grid);
    window.psGtag('event', 'select_item', {
      item_list_id: meta.item_list_id,
      item_list_name: meta.item_list_name,
      items: [{ item_id: String(card.dataset.productId), index: 1 }]
    });
  });

  function initGrids() {
    eligibleGrids().forEach((grid) => {
      if (reported.has(grid) || observed.has(grid)) return;
      // Контент рендериться динамічно (SVC chain): чекаємо і на висоту, і на картки.
      if (!grid.getBoundingClientRect().height) return;
      if (!grid.querySelector('.svc-card[data-product-id]')) return;
      observed.add(grid);
      if (observer) observer.observe(grid);
      else {
        reported.add(grid);
        emitViewItemList(grid);
      }
    });
  }

  initGrids();
  document.addEventListener('DOMContentLoaded', initGrids);
  window.addEventListener('load', initGrids);
  setTimeout(initGrids, 2000);
  setTimeout(initGrids, 5000);
  setTimeout(initGrids, 10000);
})();
